import { motion } from "framer-motion";
import { MapPin, ExternalLink, Clock, Truck } from "lucide-react";
import { useLanguage } from "@/i18n";

const MAPS_LINK = "https://share.google/CVt7BF9is5ojq3Rlg";
const MAPS_EMBED = "https://www.google.com/maps?q=Jl.%20Kali%20Baru%20Bar.%20III%20No.41%2C%20Kali%20Baru%2C%20Cilincing%2C%20Jakarta%20Utara%2014110&output=embed";

export default function Location() {
  const { t } = useLanguage();
  return (
    <section id="lokasi" className="py-24 sm:py-32 bg-[#0F1A2E]" data-testid="location-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-5 gap-10 items-stretch">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="lg:col-span-2 flex flex-col"
        >
          <p className="font-mono text-xs tracking-[0.25em] uppercase text-sky-400 font-semibold flex items-center gap-2">
            <MapPin size={14} /> {t.location.eyebrow}
          </p>
          <h2 className="mt-4 font-display font-extrabold tracking-tight text-white text-2xl sm:text-3xl lg:text-4xl">{t.location.title}</h2>
          <p className="mt-4 text-slate-400 text-base sm:text-lg">{t.location.sub}</p>

          <div className="mt-8 space-y-4 flex-1">
            <div className="bg-[#101B2E] rounded-2xl border border-slate-800 p-5 flex gap-4">
              <MapPin className="text-sky-400 shrink-0 mt-0.5" size={20} />
              <p className="font-semibold text-slate-100" data-testid="location-address">{t.location.address}</p>
            </div>
            <div className="bg-[#101B2E] rounded-2xl border border-slate-800 p-5 flex gap-4">
              <Clock className="text-sky-400 shrink-0 mt-0.5" size={20} />
              <p className="font-semibold text-slate-100">{t.location.hours}</p>
            </div>
            <div className="bg-[#101B2E] rounded-2xl border border-slate-800 p-5 flex gap-4">
              <Truck className="text-sky-400 shrink-0 mt-0.5" size={20} />
              <p className="font-semibold text-slate-100">{t.location.fleet}</p>
            </div>
          </div>

          <a
            href={MAPS_LINK}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="maps-link-btn"
            className="mt-8 inline-flex items-center justify-center gap-2.5 bg-sky-500 hover:bg-sky-400 text-white font-semibold px-7 py-4 rounded-full transition-colors w-fit"
          >
            {t.location.openMaps} <ExternalLink size={17} />
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.97 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.1 }}
          className="lg:col-span-3 clip-industrial overflow-hidden border-4 border-slate-700/60 shadow-[0_30px_60px_-20px_rgba(0,0,0,0.6)] min-h-[380px]"
        >
          <iframe
            title="Lokasi CV. Sinar Al Mubarokah — Cilincing, Jakarta Utara"
            src={MAPS_EMBED}
            className="w-full h-full min-h-[380px]"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            data-testid="maps-embed"
          />
        </motion.div>
      </div>
    </section>
  );
}
